export default __webpack_public_path__ + "static/media/bloodforblood.4123871e.png";